import { Pricing } from "@/modules/ooc/pricing";

export default class Modifier {
  name: string = "";
  original_name: string = "";
  id: string = "";
  external_id: string = "";
  local_name: string = "";
  pricing_type: string = "";
  pricing: any;
  original_local_name: string = "";
  quantifiable: boolean = false;

  constructor(data) {
    if (data) {
      this.id = data.id || "";
      this.name = data.name || "";
      this.original_name = data.name || "";
      this.quantifiable = data.quantifiable || "";
      this.local_name = data.local_name || "";
      this.original_local_name = data.local_name || "";
      this.pricing = new Pricing(data.pricing) || "";
    }
  }
}
